<template>
	<div class="container-modal form-modal">
		<div class="container-holder">
			<div class="header-modal">
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
						<path
							stroke-width="1.5"
							vector-effect="non-scaling-stroke"
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
						/>
					</svg>
				</div>
				<div class="title">Alege metoda de plată</div>
				<div class="description">
					Alege plata cu cardul sau prin transfer bancar.
				</div>
			</div>
			<div class="form-section">
				<div class="input-group-tbf w-mob-100">
					<label class="label-input" for="payment_method">Alege metoda de plată</label>
					<div class="input-box">
						<multiselect id="payment_method" class="select-tags-tbf" v-model="typePayment" :options="['online', 'op']" :show-labels="false" :allow-empty="false" :searchable="false">
							<template slot="singleLabel" slot-scope="props">
								<span class="option__title">{{ $t("register_options." + props.option) }}</span>
							</template>
							<template slot="option" slot-scope="props">
								<span class="option__title">{{ $t("register_options." + props.option) }}</span>
							</template>
						</multiselect>
					</div>
				</div>

				<template v-if="typePayment == 'online'">
					<div
						class="input-group-tbf w-mob-100"
						v-bind:class="{ has_error: $v.card.card_number.$error || stripeError != '' || cardErrors.cardNumber, complete: card.card_number != '' && !$v.card.card_number.$error }"
						id="payment"
					>
						<label class="label-input" for="card_number">Număr card</label>
						<div class="input-box">
							<input
								id="card_number"
								type="tel"
								:placeholder="$t('register.card_number_placeholder')"
								class="input-text"
								v-model="card.card_number"
								v-cardformat:formatCardNumber
								maxlength="19"
							/>
						</div>
						<div class="error-msg" v-if="cardErrors.cardNumber">{{ cardErrors.cardNumber }}</div>
						<div class="error-msg" v-else-if="stripeError != ''">{{ stripeError }}</div>
					</div>

					<div
						class="input-group-tbf w-mob-100 w-tbf-100"
						v-bind:class="{ has_error: $v.card.card_expiration.$error || cardErrors.cardExpiry, complete: card.card_expiration != '' && !$v.card.card_expiration.$error }"
					>
						<label class="label-input" for="card_expired">Data expirării</label>
						<div class="input-box">
							<input
								id="card_expired"
								type="tel"
								:placeholder="$t('register.validity_date_placeholder')"
								class="input-text"
								v-model="card.card_expiration"
								v-cardformat:formatCardExpiry
								maxlength="9"
							/>
						</div>
						<div class="error-msg" v-if="cardErrors.cardExpiry">{{ cardErrors.cardExpiry }}</div>
					</div>

					<div
						class="input-group-tbf w-mob-100 w-tbf-100"
						v-bind:class="{
							has_error: $v.card.card_cvc.$error || cardErrors.cardCvc,
							complete: card.card_cvc != '' && !$v.card.card_cvc.$error,
							'view-tooltip': activeTooltip == 'card_cvc',
						}"
					>
						<label class="label-input" for="cvc_card">Cod de securitate</label>
						<div class="input-box">
							<input id="cvc_card" type="tel" :placeholder="$t('register.cvc_placeholder')" class="input-text" v-model="card.card_cvc" v-cardformat:formatCardCVC maxlength="4" />
						</div>
						<div class="error-msg" v-if="cardErrors.cardCvc">{{ cardErrors.cardCvc }}</div>
					</div>
				</template>
				<template v-else>
					<div class="info-text">{{ $t("register.text_op_selection") }}</div>
				</template>
			</div>
			<div class="submit-form">
				<button class="button-submit" id="buttonSubmitStep3" @click="goNextStep">
					<div class="loader-spin" v-if="loadingSubmit"></div>
					<div class="text" v-else>{{ typePayment == "online" ? $t("register.button-action-3") : $t("register.button-op-submit") }}</div>
				</button>
			</div>

			<!-- <div class="powered-by" v-if="typePayment == 'online'">
				<a href="https://stripe.com" target="_blank">
					<img src="/build/images/powered_by_stripe.png" />
				</a>
			</div> -->
		</div>
	</div>
</template>

<script>
import CloseIcon from "../Icons/Close";
import IconPlus from "../Icons/Plus";
import IconInfo from "../Icons/Info";
import IconCircleCheck from "../Icons/CircleCheck";
import InformationIcon from "../Icons/Information";
import IconCard from "../Icons/Card";
import IconDate from "../Icons/Date";
import PasswordIcon from "../Icons/Password";
import IconCart from "../Icons/Cart";
import IconDots from "../Icons/Dots";

import { required } from "vuelidate/lib/validators";
export default {
	data() {
		return {
			card: {
				card_number: "",
				card_expiration: "",
				card_cvc: "",
			},
			cardErrors: {},
			packageActive: {},
			packagesList: {},
			stripeError: "",
			activeTooltip: "",
			cuponCode: "",
			newPrices: [],
			errorCoupon: false,
			typePayment: "online",
			loadingSubmit: false,
		};
	},
	props: {
		user: Object,
	},
	components: {
		CloseIcon,
		IconPlus,
		IconInfo,
		IconCircleCheck,
		InformationIcon,
		IconCard,
		IconDate,
		PasswordIcon,
		IconCart,
		IconDots,
	},
	validations: {
		card: {
			card_number: { required },
			card_expiration: { required },
			card_cvc: { required },
		},
	},
	async mounted() {
		// this.logoAnim();
	},
	methods: {
		goNextStep() {
			var btnSubmit = document.getElementById("buttonSubmitStep3");
			btnSubmit.disabled = true;
			this.loadingSubmit = true;

			if (this.typePayment == "online") {
				this.cardErrors = {};
				this.stripeError = "";
				var cardError = false;
				// validate card number
				if (!this.$cardFormat.validateCardNumber(this.card.card_number)) {
					this.cardErrors.cardNumber = this.$t("validator.invalid_credit_card");
					cardError = true;
				}

				// validate card expiry
				if (!this.$cardFormat.validateCardExpiry(this.card.card_expiration)) {
					this.cardErrors.cardExpiry = this.$t("validator.invalid_credit_card_date");
					cardError = true;
				}

				// validate card CVC
				if (!this.$cardFormat.validateCardCVC(this.card.card_cvc)) {
					this.cardErrors.cardCvc = this.$t("validator.invalid_credit_card_cvc");
					cardError = true;
				}

				if (!cardError) {
					axios
						.post("/payment", {
							number: this.card.card_number,
							exp_month: this.card.card_expiration.substring(0, 2),
							exp_year: this.card.card_expiration.substring(5, 9),
							cvc: this.card.card_cvc,
						})
						.then(({ data }) => {
							this.$auth.fetch();
							this.$router.push("/register-success");
						})
						.catch((error) => {
							if (error.response.data.payment_intent && error.response.data.payment_intent.status == "requires_payment_method") {
								var payment_intent = error.response.data.payment_intent;
								var _this = this;
								let stripe = Stripe(process.env.VUE_APP_STRIPEPUBLISHABLE_KEY);

								stripe
									.confirmCardPayment(payment_intent.client_secret, {
										payment_method: {
											card: {
												token: error.response.data.t_id,
											},
										},
									})
									.then(function(result) {
										if (result.error) {
											_this.stripeError = result.error.message;
											btnSubmit.disabled = false;
											this.loadingSubmit = false;
										} else {
											axios.post("/set-as-active", { result }).then(({ data }) => {
												_this.$auth.fetch();
												_this.$router.push("/register-success");
											});
										}
									});
							} else {
								this.stripeError = error.response.data.message;
								btnSubmit.disabled = false;
								this.loadingSubmit = false;
							}
						});
				} else {
					btnSubmit.disabled = false;
					this.loadingSubmit = false;
				}
			} else {
				this.$router.push("/register-success-op");
			}
		},
		handleAnimationLogo(anim) {
			this.anim_logo = anim;
			this.anim_logo.setSpeed(1);
		},
		logoAnim() {
			// if(this.finished && !this.bird_noti){
			// 	this.finished = false;
			// 	this.anim_logo.play();
			// 	setTimeout(() => {
			// 		this.anim_logo.stop();
			// 		this.finished = true;
			// 	}, 5000);
			// }
		},
		checkCode() {
			var btnApply = $(".btn-apply");
			var btnApplyLoader = $(".btn-apply .loader");
			var btnApplyText = $(".btn-apply .text");

			btnApply.addClass("loading");
			btnApplyLoader.addClass("onProgress");
			this.errorCoupon = false;

			axios.post("validate-coupon", { coupon: this.cuponCode }).then((data) => {
				if (data.data.is_valid) {
					btnApplyLoader.addClass("finish");
					setTimeout(() => {
						btnApplyText.html(this.$t("btn-submit.success"));
						btnApply.addClass("completed");
						btnApplyLoader.removeClass("onProgress finish");
						btnApply.removeClass("loading");
						setTimeout(() => {
							btnApply.removeClass("completed");
							btnApply.attr("disabled", false);
							btnApplyText.html(this.$t("register.step-3.coupon.apply-success"));

							this.newPrices = data.data.values;
						}, 1000);
					}, 300);
				} else {
					btnApplyLoader.addClass("finish");
					setTimeout(() => {
						btnApplyText.html(this.$t("register.step-3.coupon.apply-error"));
						btnApply.addClass("error");
						btnApplyLoader.removeClass("onProgress finish");
						btnApply.removeClass("loading");
						setTimeout(() => {
							btnApply.removeClass("error");
							btnApplyText.html(this.$t("register.step-3.coupon.apply"));
							btnApply.attr("disabled", false);
							this.errorCoupon = true;
							this.newPrices = [];
						}, 1000);
					}, 300);
				}
			});
		},
		selectLanguage(value, id) {
			this.user.language = value.name;
		},
		selectPlan(packageItem) {
			this.packageActive = packageItem;
			setTimeout(function() {
				$("#content").animate(
					{
						scrollTop: $("#payment").offset().top,
					},
					250
				);
			}, 250);
		},
	},
};
</script>
